/**
 * @generated SignedSource<<1cd71c4a7f1c45db29bc714f66b63e19>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useAuth_user$data = {
  readonly profile: {
    readonly email: string | null;
  } | null;
  readonly socialNetworks: ReadonlyArray<{
    readonly socialId?: string | null;
    readonly socialNetwork?: {
      readonly name: string | null;
    } | null;
    readonly status?: string | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutAuthActions_buyer">;
  readonly " $fragmentType": "useAuth_user";
};
export type useAuth_user$key = {
  readonly " $data"?: useAuth_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"useAuth_user">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "Profile",
  "kind": "LinkedField",
  "name": "profile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "socialId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "SocialNetwork",
    "kind": "LinkedField",
    "name": "socialNetwork",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "socialNetworks",
  "plural": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "FacebookSocialNetwork",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "GoogleSocialNetwork",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "AppleSocialNetwork",
      "abstractKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useAuth_user",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "checkoutAuthActions_buyer",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "UserExistsMetadataType",
          "kind": "LinkedField",
          "name": "authMetadata",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "emailOnly",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v2/*: any*/)
      ],
      "args": null,
      "argumentDefinitions": []
    },
    (v0/*: any*/),
    (v2/*: any*/)
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "7b01e3a8b560872acea8f9d7356c651c";

export default node;
